import { DeleteSmall, LayoutThreeColumns, LayoutTwoColumns } from '@wix/wix-ui-icons-common';

import { TIPTAP_LAYOUT_TYPE } from './../../ricos-content';
import type { EditorPlugin } from './../../ricos-types';
import { quickActionsModalSections, RicosPluginToolbarNames } from './../../ricos-types';
import { INSERT_PLUGIN_BUTTONS } from './../../editor-common';

import { INSERT_LAYOUT_BUTTON, PLUGIN_TOOLBAR_DELETE_BUTTON } from './data-hooks';
import { layoutConverter } from './layout-converter';
import { layoutExtension } from './layout-extension';
import { LAYOUT_INSERT_MODAL_ID, LayoutInsertModal } from './modals/layout-insert-modal';
import type { LayoutEditorConfig } from './shared';
import { getToolbarReferenceElement, toolbarsToAddIn } from './shared';

export const pluginLayout = (
  config: LayoutEditorConfig = { showInQuickActions: false, showInToolbars: false }
): EditorPlugin => ({
  type: TIPTAP_LAYOUT_TYPE,
  config,
  pmMarkConverters: [],
  pmNodeConverters: [layoutConverter],
  tiptapExtensions: [layoutExtension],
  textButtons: [],
  toolbar: {
    names: [RicosPluginToolbarNames.LAYOUT],
    resolveReferenceElement: tiptapEditor =>
      getToolbarReferenceElement(tiptapEditor, '[data-layout-handle]'),
    getButtons: () => [
      {
        id: 'deleteLayout',
        dataHook: PLUGIN_TOOLBAR_DELETE_BUTTON,
        tooltip: 'Layouts_LayoutDelete_Tooltip',
        icon: DeleteSmall,
        command: ({ tiptapEditor, attributes }) => {
          tiptapEditor.commands.deleteNode(attributes.selectedNode.attrs.id);
        },
      },
    ],
  },
  getAddButtons: (_config, services) =>
    config.showInToolbars
      ? [
          {
            id: `${TIPTAP_LAYOUT_TYPE}.insert`,
            label: INSERT_PLUGIN_BUTTONS.LAYOUT,
            dataHook: INSERT_LAYOUT_BUTTON,
            icon: LayoutThreeColumns,
            tooltip: 'Layout_InsertButton_Tooltip',
            toolbars: toolbarsToAddIn,
            command: ({ referenceElement }) => {
              services.modals?.togglePluginPanel({
                id: LAYOUT_INSERT_MODAL_ID,
                Component: LayoutInsertModal,
                componentProps: {},
                isMobile: services.context.isMobile,
                positioning: {
                  referenceElement,
                  placement: 'bottom',
                },
                mobileLayout: 'drawer',
              });

              return true;
            },
            menuConfig: {
              tags: 'Layout_InsertButton',
              group: 'basic',
            },
          },
        ]
      : [],
  getQuickActions: () =>
    config.showInQuickActions
      ? [
          {
            id: 'twoColumns',
            title: 'QuickActionsPlugin_ActionTitle_TwoColumns',
            tags: ['layout', 'grid', 'cell'],
            icon: LayoutTwoColumns,
            section: quickActionsModalSections.FormatLayout,
            command: ({ editor }) => editor.commands.insertLayout(2),
          },
          {
            id: 'threeColumns',
            title: 'QuickActionsPlugin_ActionTitle_ThreeColumns',
            tags: ['layout', 'grid', 'cell'],
            icon: LayoutThreeColumns,
            section: quickActionsModalSections.FormatLayout,
            command: ({ editor }) => editor.commands.insertLayout(3),
          },
        ]
      : [],
});
